import { Box, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

import Enums from '@core/types/api/Enums';

import commandLogo from '../../public/command-alkon-logo.png';
import sysdyneLogo from '../../public/sysdyne-logo.jpeg';

export const getIntegrationLogo = (integrationType: Enums.IntegrationType): ReactNode => {
  const theme = useTheme();

  switch (integrationType) {
    case Enums.IntegrationType.Apex:
    case Enums.IntegrationType.Integra:
    case Enums.IntegrationType.Series:
    case Enums.IntegrationType.Connect:
      return (
        <Box
          sx={{
            backgroundColor: theme.palette.SlabGray[0],
            borderRadius: 3,
            width: '4rem',
            height: '4rem',
            padding: '4px',
          }}
        >
          <img
            alt='command-alcon-logo'
            style={{
              objectFit: 'scale-down',
              objectPosition: 'center',
              height: '100%',
              width: '100%',
            }}
            src={commandLogo}
          />
        </Box>
      );

    case Enums.IntegrationType.Sysdyne:
      return (
        <Box
          sx={{
            backgroundColor: theme.palette.SlabGray[0],
            borderRadius: 3,
            width: '4rem',
            height: '4rem',
            padding: '4px',
          }}
        >
          <img
            alt='sysdyne-logo'
            style={{
              objectFit: 'scale-down',
              objectPosition: 'center',
              height: '100%',
              width: '100%',
            }}
            src={sysdyneLogo}
          />
        </Box>
      );
    default:
      return null;
  }
};
